import React from 'react';
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Nabvar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp';
import Cart from '../Components/Cart/Cart';

export default function PageLayout() {
    const isScreenLarge = useMediaQuery('(min-width: 900px)');

    return (
        <div>
            {isScreenLarge ? (
                <>
                    <Nabvar />
                    <Outlet />
                    <Footer />
                    <BtnWhatsapp />
                    <Cart />
                </>
            ) : (
                <div className='section-bg-color'>
                    <Nabvar />
                    <div className='espaciobg'></div>
                    <Outlet />
                    <Footer />
                    <BtnWhatsapp />
                    <Cart />
                </div>
            )}
            <div className='espaciobg2'></div>
        </div>
    );
}
